module.exports = __webpack_public_path__ + "static/img/jiaofei.59fa191.png";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial/jiaofei.png
// module id = 26Aj
// module chunks = 14